import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  editorContainer: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 120px)",
    width: "100%",
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down("xs")]: {
      height: "calc(100vh - 56px)",
    },
  },
  toolbar: {
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    flexWrap: "nowrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0.75, 1),
    },
  },
  content: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
    position: "relative",
  },
  // Sidebar desktop/tablet
  sidebar: {
    width: 250,
    flexShrink: 0,
    padding: theme.spacing(1.5),
    borderRight: `1px solid ${theme.palette.divider}`,
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    transition: "width 0.2s ease",
    [theme.breakpoints.down("sm")]: {
      width: 200,
      padding: theme.spacing(1),
    },
    // On xs (mobile) the sidebar renders in a Drawer — hide inline
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  // Inner content of sidebar (reused in Drawer on mobile)
  sidebarContent: {
    width: 220,
    padding: theme.spacing(1.5),
    overflowY: "auto",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  reactFlowWrapper: {
    flex: 1,
    height: "100%",
    position: "relative",
    backgroundColor: theme.palette.background.default,
    // Resaltado del recorrido durante la previsualización (0383 FS-2.7). Se aplica por
    // className del nodo para no tocar el `data` de los nodos, que es lo que se persiste.
    "& .react-flow__node.sim-active": {
      filter: "drop-shadow(0 0 10px rgba(76, 175, 80, 0.9))",
      outline: `3px solid ${theme.palette.success.main}`,
      outlineOffset: 3,
      borderRadius: 10,
      zIndex: 20,
    },
    "& .react-flow__node.sim-visited": {
      outline: `2px solid ${theme.palette.success.light}`,
      outlineOffset: 2,
      borderRadius: 10,
    },
    "& .react-flow__node.sim-dimmed": {
      opacity: 0.45,
    },
  },
  simLockBanner: {
    position: "absolute",
    top: 12,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 15,
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 20,
    backgroundColor:
      theme.palette.type === "dark" ? "rgba(33,150,243,0.18)" : "#e3f2fd",
    border: `1px solid ${theme.palette.info.main}`,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[2],
    pointerEvents: "none",
  },
  // Floating toggle button — visible only on mobile
  sidebarToggleFab: {
    position: "absolute",
    top: 10,
    left: 10,
    zIndex: 5,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[2],
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  nodeCard: {
    marginBottom: theme.spacing(1),
    cursor: "pointer",
    transition: "background-color 0.15s ease",
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  nodeCardContent: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: `${theme.spacing(1.25)} ${theme.spacing(1.5)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(1)} ${theme.spacing(1.25)} !important`,
    },
  },
  nodeIcon: {
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      fontSize: 17,
    },
  },
  nodeLabel: {
    fontWeight: 500,
    fontSize: 14,
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
  nodeBadge: {
    display: "none",
  },
  categoryTitle: {
    fontWeight: 600,
    fontSize: 12,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    "&:first-of-type": {
      marginTop: 0,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
    },
  },
}));
